module.exports = __webpack_public_path__ + "static/media/logo-footer.4a6095a9.svg";